import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { FolderForm } from '../model';
import { StatusSelect } from './company-access-fields';

type Props = {
  open: boolean;
  form: FolderForm;
  isSaving: boolean;
  error: string | null;
  onClose: () => void;
  onSave: () => void;
  onChange: (form: FolderForm) => void;
};

export const FolderFormDialog = ({
  open,
  form,
  isSaving,
  error,
  onClose,
  onSave,
  onChange,
}: Props) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
    <DialogTitle>
      {form.id ? 'Редактирование папки' : 'Создание папки'}
    </DialogTitle>
    <DialogContent>
      <Stack spacing={2} sx={{ mt: 1 }}>
        {error && <Alert severity="error">{error}</Alert>}

        <TextField
          label="Название папки"
          value={form.name}
          onChange={(e) => onChange({ ...form, name: e.target.value })}
          fullWidth
        />
        <StatusSelect
          value={form.status}
          onChange={(status) => onChange({ ...form, status })}
        />
        <FormControlLabel
          control={
            <Switch
              checked={form.isSequentialLock}
              onChange={(e) =>
                onChange({ ...form, isSequentialLock: e.target.checked })
              }
            />
          }
          label="Блокировать следующую папку до полного просмотра"
        />
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={isSaving}>
        Отмена
      </Button>
      <Button variant="contained" onClick={onSave} disabled={isSaving}>
        Сохранить
      </Button>
    </DialogActions>
  </Dialog>
);

type ConfirmDeleteDialogProps = {
  open: boolean;
  title: string;
  description: string;
  isDeleting: boolean;
  error: string | null;
  confirmLabel?: string;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmDeleteDialog = ({
  open,
  title,
  description,
  isDeleting,
  error,
  confirmLabel = 'Удалить',
  onClose,
  onConfirm,
}: ConfirmDeleteDialogProps) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <Stack spacing={2}>
        {error && <Alert severity="error">{error}</Alert>}
        <Typography>{description}</Typography>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={isDeleting}>
        Отмена
      </Button>
      <Button color="warning" variant="contained" onClick={onConfirm} disabled={isDeleting}>
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);
